import CropFreeIcon from '@mui/icons-material/CropFree';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { CernQrCodeValue } from '../../api/types';
import { AdamsError, getErrorMessage } from '../../utils/errors';
import { cameraScanningErrorsNotToBeShown } from '../../utils/utils';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { QRScanner } from '../QRScanner/QRScanner';

interface ScanProps {
    translations: Record<string, string>;
}

export const Scan: React.FC<ScanProps> = ({ translations }) => {
    const [scanError, setScanError] = useState<AdamsError | null>(null);
    const [accessPointCodeValue, setAccessPointCodeValue] = useState('');
    const [nonceValue, setNonceValue] = useState('');
    const [visitorNonceValue, setVisitorNonceValue] = useState('');
    const [displayQRScanner, setDisplayQRScanner] = useState(true);

    const navigate = useNavigate();

    const handleClose = () => {
        navigate('/');
    };

    const handleDetect = (value: CernQrCodeValue) => {
        if (value) {
            const { accessPointCode, nonce, visitorNonce } = value;
            setScanError(null);

            if (accessPointCode) {
                setAccessPointCodeValue(accessPointCode);
            } else if (nonce) {
                setNonceValue(nonce);
            } else if (visitorNonce) {
                setVisitorNonceValue(visitorNonce);
            } else {
                setScanError({ message: translations.ERROR_NOT_CERN_QR_CODE });
            }
        } else {
            setScanError({ message: translations.ERROR_NOT_CERN_QR_CODE });
        }
    };

    const handleError = (error: AdamsError) => {
        const errorMessage = getErrorMessage(error);
        if (errorMessage && !cameraScanningErrorsNotToBeShown.includes(errorMessage)) {
            setDisplayQRScanner(false);
            setScanError(error);
        }
    };

    useEffect(() => {
        if (accessPointCodeValue?.length) {
            navigate(`/accesspoint/${accessPointCodeValue}`);
        }

        if (nonceValue?.length) {
            navigate(`/functions/temporary-badge/${nonceValue}`);
        }

        if (visitorNonceValue?.length) {
            navigate(`/functions/visitor-card/${visitorNonceValue}`);
        }
    }, [accessPointCodeValue, nonceValue, visitorNonceValue, scanError, navigate]);

    return (
        <Card>
            <CardContent>
                {scanError && (
                    <ErrorMessage
                        errorMessage={getErrorMessage(scanError)}
                        title={translations.ERROR_NOT_CERN_QR_CODE_TITLE}
                        translations={translations}
                    />
                )}

                {displayQRScanner && (
                    <QRScanner
                        onDetect={handleDetect}
                        onClose={handleClose}
                        onError={handleError}
                        translations={translations}
                    />
                )}

                <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<CropFreeIcon style={{ fontSize: '1rem' }} />}
                    style={{ display: 'none' }}
                    onClick={() => setDisplayQRScanner(true)}
                >
                    {translations.GLOBAL_SCAN_BUTTON}
                </Button>
            </CardContent>
        </Card>
    );
};
